import type { KeyboardEvent } from "react";

export function isImeComposing(e: KeyboardEvent): boolean {
  return (e.nativeEvent as globalThis.KeyboardEvent).isComposing || e.keyCode === 229;
}

export function isEnterSubmit(e: KeyboardEvent, opts?: { allowShift?: boolean }): boolean {
  const shiftOk = opts?.allowShift || !e.shiftKey;
  return e.key === "Enter" && shiftOk && !isImeComposing(e);
}
